// D-265 §1: deleting an engagement shows "deleted" only AFTER the server answers.
// Success -> onSuccess (message + refresh). Failure -> onError only; no success message was shown before.
export async function deleteEngagementConfirmed(
  del: () => Promise<unknown>,
  cb: { onSuccess: () => void; onError: (err: unknown) => void },
): Promise<boolean> {
  try {
    await del();
  } catch (err) {
    cb.onError(err);
    return false;
  }
  cb.onSuccess();
  return true;
}
